import { type Static, Type } from "@sinclair/typebox"
import { IdSchema, IsoTimestampSchema, NonEmptyStringSchema } from "./common"

export const ClerkInvitationStatusSchema = Type.Union([
  Type.Literal("pending"),
  Type.Literal("accepted"),
  Type.Literal("revoked"),
  Type.Literal("expired"),
])

export type ClerkInvitationStatus = Static<typeof ClerkInvitationStatusSchema>

export const ClerkInvitationRecordSchema = Type.Object({
  id: IdSchema,
  emailAddress: NonEmptyStringSchema,
  status: ClerkInvitationStatusSchema,
  url: Type.Optional(NonEmptyStringSchema),
  createdAt: IsoTimestampSchema,
  updatedAt: IsoTimestampSchema,
})

export type ClerkInvitationRecord = Static<typeof ClerkInvitationRecordSchema>

export const ClerkInvitationListResponseSchema = Type.Object({
  records: Type.Array(ClerkInvitationRecordSchema, {
    maxItems: 500,
  }),
})

export type ClerkInvitationListResponse = Static<
  typeof ClerkInvitationListResponseSchema
>

export const ClerkInvitationCreateEnvelopeSchema = Type.Object({
  emailAddress: NonEmptyStringSchema,
})

export type ClerkInvitationCreateEnvelope = Static<
  typeof ClerkInvitationCreateEnvelopeSchema
>

export const ClerkInvitationCreateResponseSchema = Type.Object({
  record: ClerkInvitationRecordSchema,
})

export type ClerkInvitationCreateResponse = Static<
  typeof ClerkInvitationCreateResponseSchema
>

export const ClerkInvitationRevokeResponseSchema = Type.Object({
  record: ClerkInvitationRecordSchema,
})

export type ClerkInvitationRevokeResponse = Static<
  typeof ClerkInvitationRevokeResponseSchema
>
